import { __rest } from "tslib";
import React, { useContext, useEffect } from 'react';
import { createPortal } from 'react-dom';
import Input from '../input/input';
import { context } from './utils';
var Search = function Search(_a) {
  var props = __rest(_a, []);
  var _useContext = useContext(context),
    search = _useContext.search,
    showSearch = _useContext.showSearch;
  useEffect(function () {
    showSearch(true);
    return function () {
      return showSearch(false);
    };
  }, [showSearch]);
  if (!search.control) {
    return null;
  }
  return createPortal(React.createElement(Input, Object.assign({}, props, {
    size: props.size || 's'
  })), search.control);
};
export default Search;